import request from "../request";

export const removeTicket = ({service_id, uid}) => {
  return request({
    url: "/service/cart/remove",
    type: "DELETE",
    data: {
      service_id,
      uid
    }
  });
};

export const addTicket = (service_id, price_id) => {
  return request({
    url: "/service/cart/add",
    type: "POST",
    data: {
      service_id,
		price_id
    }
  });
};

export const removeService = ({serviceId, count}) => {
  return request({
    url: "/service/cart/scope-remove",
    type: "DELETE",
    data: {
      service_id: serviceId,
      count
    }
  });
};
